/**
 * The data field type
 *
 * @group ISOBMFF
 *
 * @beta
 */
export const DATA = 'data';
